import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DataProvider } from './src/context/DataContext';
import { Layout } from './src/components/layout/Layout';
import { Dashboard } from './src/pages/Dashboard';
import { Customers } from './src/pages/Customers';
import { Invoices } from './src/pages/Invoices';
import { InvoiceForm } from './src/pages/InvoiceForm';
import { Subscriptions } from './src/pages/Subscriptions';
import { SubscriptionForm } from './src/pages/SubscriptionForm';
import { Settings } from './src/pages/Settings';
import { PublicInvoiceView } from './src/pages/PublicInvoiceView';
export function App() {
  return <DataProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          {/* Public route - NO layout wrapper */}
          <Route path="/public/invoice/:id" element={<PublicInvoiceView data-id="element-4" />} data-id="element-3" />

          {/* Admin routes - WITH layout wrapper */}
          <Route path="*" element={<Layout data-id="element-6">
                <Routes data-id="element-7">
                  <Route path="/" element={<Dashboard data-id="element-9" />} data-id="element-8" />
                  <Route path="/customers" element={<Customers data-id="element-11" />} data-id="element-10" />
                  <Route path="/invoices" element={<Invoices data-id="element-13" />} data-id="element-12" />
                  <Route path="/invoices/new" element={<InvoiceForm data-id="element-15" />} data-id="element-14" />
                  <Route path="/invoices/:id" element={<InvoiceForm data-id="element-17" />} data-id="element-16" />
                  <Route path="/subscriptions" element={<Subscriptions data-id="element-19" />} data-id="element-18" />
                  <Route path="/subscriptions/new" element={<SubscriptionForm data-id="element-21" />} data-id="element-20" />
                  <Route path="/subscriptions/:id" element={<SubscriptionForm data-id="element-23" />} data-id="element-22" />
                  <Route path="/settings" element={<Settings data-id="element-25" />} data-id="element-24" />
                </Routes>
              </Layout>} data-id="element-5" />
        </Routes>
      </BrowserRouter>
    </DataProvider>;
}